// node-modules
import { TweenLite, TimelineMax } from 'gsap/TweenMax';

// constants
import { DOCUMENT_ELEMENT, SELECTORS } from '@/scripts/constants';

// other
import { createEvent, transitionend, toggleBodyScroll } from '@/scripts/utils';

// assets
import './Preloader.scss';

const defaults = {
  element: null,
  images: '[data-role="preloader-images"]',
  text: '[data-role="preloader-text"]',
  start: '[data-role="preloader-start"]',
  animationSelector: 'data-main-animation',
  activeClass: SELECTORS.has_preloader,
  startClass: SELECTORS.preloader_start,
  hiddenClass: SELECTORS.hidden,
  startTimeout: 3000,
};

export default class Preloader {
  constructor(props) {
    const options = Object.assign({}, defaults, props);
    this.element = options.element;
    if (!this.element) return;

    this.text = this.element.querySelector(options.text);
    this.start = this.element.querySelector(options.start);

    this.animationSelector = options.animationSelector;
    this.activeClass = options.activeClass;
    this.startClass = options.startClass;
    this.hiddenClass = options.hiddenClass;
    this.startTimeout = options.startTimeout;
  }

  play() {
    this.removePreloader();
  }

  startLoading() {
    console.log('Loading'); // eslint-disable-line no-console
    toggleBodyScroll(true, null);
    TweenLite.set(`[${this.animationSelector}]`, { autoAlpha: 0, pointerEvents: 'none' });
  }

  removePreloader() {
    const tl = new TimelineMax();
    setTimeout(() => {
      DOCUMENT_ELEMENT.classList.remove(this.activeClass);
      DOCUMENT_ELEMENT.classList.remove(this.startClass);
      DOCUMENT_ELEMENT.dispatchEvent(createEvent('preloaderEnd'));
      transitionend(this.element, 'transitionend', () => {
        console.log('Loading finished. Enjoy!'); // eslint-disable-line no-console
        toggleBodyScroll(false, null);
        this.element.remove();
        tl
          .staggerFromTo(`[${this.animationSelector}="fade-in-down"]`, 1, { y: -50 }, {
            y: 0,
            autoAlpha: 1,
            clearProps: 'all',
          }, 0.2)
          .staggerFromTo(`[${this.animationSelector}="fade-in-left"]`, 1, { x: 50 }, {
            x: 0,
            autoAlpha: 1,
            clearProps: 'all',
          }, 0.2, 0)
          .staggerFromTo(Array.from(document.querySelectorAll(`[${this.animationSelector}="fade-in-right"]`)).reverse(), 1, { x: -50 }, {
            x: 0,
            autoAlpha: 1,
            clearProps: 'all',
          }, 0.2, 0)
          .to(`[${this.animationSelector}="fade-in"]`, 1, { clearProps: 'all' }, 0.2)
          .staggerFromTo(`[${this.animationSelector}="fade-in-up"]`, 1, { y: 100 }, {
            y: 0,
            autoAlpha: 1,
            clearProps: 'all',
          }, 0.2, 0);
      });
    }, this.startTimeout);
  }
}



// WEBPACK FOOTER //
// ./components/Preloader/Preloader.js